import { createSelector } from 'reselect';
import get from 'utils/get';
import getKeywordInText from 'utils/getKeywordInText';
import laureateStories from 'state/selectors/laureateStories';

export default createSelector(
  state => laureateStories(state),
  state => get(state, 'backgroundLine.backgroundLineKeywords', []),
  (laureateStories, keywords) => {
    return Object.entries(laureateStories).reduce(
      (laureatesByTag, [slug, laureateStory]) => {
        const {
          firstName,
          middleName,
          lastName,
          image,
          contentBlocks
        } = laureateStory;

        contentBlocks.forEach(block => {
          const type = get(block, 'sys.contentType.sys.id');

          if (type === 'blockText' || type === 'blockImageText') {
            const text = get(block, 'fields.text', '');
            const id = get(block, 'sys.id', '');
            const keywordInText = getKeywordInText(text, keywords);

            if (!!keywordInText.word) {
              const encodedTag = encodeURIComponent(
                keywordInText.word.toLowerCase()
              );

              const sanitizedLaureateStory = {
                firstName,
                middleName,
                lastName,
                image,
                slug,
                id
              };

              if (!!laureatesByTag[encodedTag]) {
                laureatesByTag[encodedTag][slug] = sanitizedLaureateStory;
              } else {
                laureatesByTag[encodedTag] = {};
                laureatesByTag[encodedTag][slug] = sanitizedLaureateStory;
              }
            }
          }
        });

        return laureatesByTag;
      },
      {}
    );
  }
);
